import { FC, useEffect, useMemo } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { useTranslations } from '@altermaind/core/i18n';
import { Box } from '@altermaind/web/ui';
import { Form, SelectItem } from '@/_shared/components/Form';
import { getDepartmentsCall } from '@/departments/state/api';

type Props = {
  onDepartmentChange: (departmentId: string | undefined) => void;
};

export const ExistingDepartmentForm: FC<Props> = ({ onDepartmentChange }) => {
  const t = useTranslations('people.tableEmployees.assignDepartmentBulkDialog');
  const { control, watch } = useForm<FieldValues>({
    defaultValues: { department: undefined },
  });

  const {
    execute: executeGetDepartments,
    departmentsToShow,
    loading: loadingGetDepartments,
    success: successGetDepartments,
  } = getDepartmentsCall.hook();

  const departmentItems: SelectItem[] = useMemo(
    () =>
      (departmentsToShow ?? [])
        .filter(d => d.id && d.name)
        .map(d => ({ label: d.name as string, value: d.id as string })),
    [departmentsToShow],
  );

  const selectedDepartment = watch('department');

  useEffect(() => {
    if (!loadingGetDepartments && !successGetDepartments) {
      executeGetDepartments({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    onDepartmentChange(selectedDepartment?.value);
  }, [selectedDepartment?.value, onDepartmentChange]);

  return (
    <Box mt='m'>
      <Form.FormDropdown
        control={control}
        name='department'
        label={t('selectDepartmentLabel')}
        placeholder={t('selectDepartmentPlaceholder')}
        items={departmentItems}
        loading={loadingGetDepartments}
        backgroundColorHeader='grey/light'
        alwaysShowLabel
      />
    </Box>
  );
};
